import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import styles from "./../icon.css";
var IconRadioButtonOutline = function (_a) {
    var customStyle = _a.customStyle;
    return (_jsx("svg", { height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", className: classNames(customStyle, styles.fill), children: _jsx("path", { d: "m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z", fillRule: "evenodd" }) }));
};
export default IconRadioButtonOutline;
